import { ChannelAllowExportEnum, ChannelEnum } from "@c2b/muven-commons";
import { ChannelModel } from "../../channel/models/ChannelModel";

export class ChannelStatusSynchronizationModel {
    id: string = "";
    name: string = "";
    isActive: boolean = false;
    brand: number|string = 0;
    category: number|string = 0;
    attribute: number|string = 0;
    product: number|string = 0;
    product_category: number|string = 0;
    product_store: number|string = 0;
    product_image: number|string = 0;
    hook_event:number|string = 0;
    order:number|string = 0;
    enum_channel: ChannelEnum;
    channel: ChannelModel = new ChannelModel()

    constructor(c?: Partial<ChannelStatusSynchronizationModel>) {
        Object.assign(this, c)

        this._parseNumbers();
    }

    setChannel(channel: ChannelModel):void {
        this.channel = channel;
    }

    hasPendingSync():boolean {
        const result = this.product_store > 0 ||
            this.order > 0 ||
            this.hook_event > 0;
        
        let resultWhenAllowExportAll = false;

        if (this.channel.allowExport === ChannelAllowExportEnum.All) {
            resultWhenAllowExportAll = this.product > 0 ||
                this.product_image > 0 ||
                this.attribute > 0 ||
                this.brand > 0 ||
                this.category > 0;
        }

        return result || resultWhenAllowExportAll
    }

    private _parseNumbers():void {
        this.brand = Number(this.brand);
        this.attribute = Number(this.attribute);
        this.category = Number(this.category);
        this.product = Number(this.product);
        this.product_category = Number(this.product_category);
        this.product_store = Number(this.product_store);
        this.product_image = Number(this.product_image);
        this.hook_event = Number(this.hook_event);
        this.order = Number(this.order);
    }
}
